module.exports = __webpack_public_path__ + "media/images/area/icon_weather_25-d54a541db9786899e32cc756dd3aabff.png";